import { render, staticRenderFns } from "./RegisterUserV2.vue?vue&type=template&id=45351588"
import script from "./RegisterUserV2.vue?vue&type=script&lang=ts"
export * from "./RegisterUserV2.vue?vue&type=script&lang=ts"
import style0 from "./RegisterUserV2.vue?vue&type=style&index=0&id=45351588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports